import React, { useState } from 'react';

// project-imports
import { GoogleAnalyticsEnum, pageView, triggerFunction } from '../../utils/google-analytics';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import ContactUsForm from '../../components/contact/ContactUsForm';
import ContactUsStencil from './ContactUsStencil';

// Reading environment variable start
const OFFICIAL_WEBSITE_URL = process.env.REACT_APP_OFFICIAL_WEBSITE_URL;
const OFFICIAL_EMAIL_ADDRESS = process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS;
const OFFICIAL_PHONE_NUMBER = process.env.REACT_APP_OFFICIAL_PHONE_NUMBER;
// Reading environment variable end

const ContactUs = () => {

    // State variable initialization
    const [stencilLoading, setStencilLoading] = useState(true);

    // Loading timeout
    setTimeout(() => {
        setStencilLoading(false);
    }, 1000)

    if (stencilLoading) {
        // Loading stencil
        return <ContactUsStencil stencilLoading={stencilLoading} />
    }
    return (
        <>
            <SEO title="Contact Us | Longswitch Academy" url={process.env.PUBLIC_URL + '/contact-us'} /> {/* Set SEO title */}
            {pageView(window.location.pathname, GoogleAnalyticsEnum.CONTACT_US)}
            <Layout searchDisable={true}>
                <BreadcrumbOne
                    title="Contact Us" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    googleEnum={GoogleAnalyticsEnum.CONTACT_US_TO_HOME}
                    currentUrl="Contact Us"
                />
                <div className="eduvibe-contact-us edu-contact-us-area edu-section-gap bg-color-white">
                    <div className="container eduvibe-animated-shape">
                        <div className="row g-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="pre-title">Need Help?</span>
                                    <h3 className="title">Get In Touch With Us</h3>
                                </div>
                            </div>
                        </div>
                        <div className="row y-gap-30 pt--50">
                            <div className="col-lg-6">
                                <div className="contact-info pr_lg--0 pr_md--0 pr_sm--0">
                                    <div className="row y-gap-30">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">

                                            <div className="contact-address-card-1 website w-100">
                                                <div className="inner">
                                                    <div className="icon">
                                                        <i className="ri-global-line"></i>
                                                    </div>
                                                    <div className="content">
                                                        <h6 className="title">Our Website</h6>
                                                        <p className="text-break fs-15"><a href={OFFICIAL_WEBSITE_URL} target="_blank" onClick={() => triggerFunction(GoogleAnalyticsEnum.LINK, GoogleAnalyticsEnum.CONTACT_US_OFFICAL_WEBSITE)} rel="noreferrer">www.longswitchacademy.com</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
                                            <div className="contact-address-card-1 phone w-100">
                                                <div className="inner">
                                                    <div className="icon">
                                                        <i className="icon-Headphone"></i>
                                                    </div>
                                                    <div className="content">
                                                        <h6 className="title">Call Us On</h6>
                                                        <p><a href={`tel: ${OFFICIAL_PHONE_NUMBER}`} onClick={() => triggerFunction(GoogleAnalyticsEnum.LINK, GoogleAnalyticsEnum.CONTACT_US_OFFICIAL_PHONE_NUMBER)}
                                                        >{OFFICIAL_PHONE_NUMBER}</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
                                            <div className="contact-address-card-1 email w-100">
                                                <div className="inner">
                                                    <div className="icon">
                                                        <i className="icon-mail-open-line"></i>
                                                    </div>
                                                    <div className="content">
                                                        <h6 className="title">Email Us</h6>
                                                        <p className="text-break">
                                                            <a
                                                                href={`mailto:${OFFICIAL_EMAIL_ADDRESS}`}
                                                                onClick={() => triggerFunction(GoogleAnalyticsEnum.LINK, GoogleAnalyticsEnum.CONTACT_US_OFFICIAL_EMAIL_ADDRESS)}>
                                                                {OFFICIAL_EMAIL_ADDRESS}
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
                                            <div className="contact-address-card-1 location w-100">
                                                <div className="inner">
                                                    <div className="icon">
                                                        <i className="icon-map-pin-line"></i>
                                                    </div>
                                                    <div className="content">
                                                        <h6 className="title">Our Location</h6>
                                                        <p>125-126, J9 High
                                                            Street, Vesu, Surat, Gujarat, India-395007.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <ContactUsForm formStyle="rnt-contact-form rwt-dynamic-form row" />
                            </div>
                        </div>
                        {/* Modified by Longswitch Team added xxl for that nest hub max scroll issue  */}
                        <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                            <div className="shape-image shape-image-1">
                                <img src="/images/shapes/shape-04-01.png" alt="Shape Thumb" />
                            </div>
                            <div className="shape-image shape-image-2">
                                <img src="/images/shapes/shape-02-08.png" alt="Shape Thumb" />
                            </div>
                            <div className="shape-image shape-image-3">
                                <img src="/images/shapes/shape-15.png" alt="Shape Thumb" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="edu-contact-map-area edu-section-gapBottom">
                    <div className="container mb--80">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="google-map alignwide">
                                    <iframe title="Google Map"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.1521354243064!2d72.7808755485505!3d21.146343030490513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f0c4484f763%3A0x7c59df6cd702dc97!2sLongswitch%20Software%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1706528510580!5m2!1sen!2sin"
                                        height="500" frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0">
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>

    )
}
export default ContactUs;